import React from 'react';
import styled from 'styled-components';
import LabelWrapper from '../LabelWrapper';
import { StyledInputTextArea } from './StyledComponents';
import { TextAreaProps } from './types';

/** @deprecated use InputTextArea from @bb/elements-web instead */
export const InputTextArea: React.FC<TextAreaProps> = ({
  error,
  label,
  placeholder,
  width,
  required,
  className,
  imposeWrap,
  ...props
}) => (
  <LabelWrapper
    label={label}
    error={error}
    required={required}
    className={className}
  >
    <StyledInputTextArea
      {...props}
      $width={width}
      $imposeWrap={imposeWrap}
      placeholder={
        placeholder || (typeof label === 'string' ? label : undefined)
      }
      required={required}
    />
  </LabelWrapper>
);

export default styled(InputTextArea)``;
